module.exports = __webpack_public_path__ + "static/img/fingerpost_express_1.d7a5eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_1.jpg
// module id = WPuq
// module chunks = 0